import { render, staticRenderFns } from "./CinemaList.vue?vue&type=template&id=2c2a03a6&"
import script from "./CinemaList.vue?vue&type=script&lang=ts&"
export * from "./CinemaList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports